import React from 'react'
import TitleWithBackNavigation from '../../../../components/TitleWithBackNavigation'
import { Col, Collapse, Row } from 'antd'
import { benefitsData, colorClasses } from '../../../../config/utils/constants';


const BenefitsOfMobrage = () => {
    return (
        <div className='w-full'>
            <TitleWithBackNavigation title={'Benefits Of Mobrage'} link={'/settings'} />
            <Row className='w-full my-4' justify={'space-between'} gutter={[16, 32]}>
                {
                    benefitsData?.map((benefit, index) => {
                        const textColorClass = colorClasses[benefit.color] || 'text-black';
                        return (
                            <Col lg={12} md={12} sm={12} xs={24} className='benefits-collapse' key={index}>
                                <Collapse
                                    items={[
                                        {
                                            key: benefit.key,
                                            label: <div className={`${textColorClass} flex items-center gap-4`}>
                                                <span className='p-2 rounded-full bg-[#f3f6f8]'>{benefit.icon}</span>
                                                <span>{benefit.title}</span>
                                            </div>,
                                            children: <p>{benefit.content}</p>,
                                        },
                                    ]}
                                    expandIconPosition='end'

                                />
                            </Col>
                        )
                    })
                }

            </Row>
        </div>
    )
}

export default BenefitsOfMobrage